import {
	PropsWithChildren,
	Dispatch,
	SetStateAction,
} from 'react';
import styles from './PagedDialog.module.scss';

type TMenuProps = {
	context?: {
		activeMenu: number;
		setActiveMenu: Dispatch<SetStateAction<number>>;
		activeSubMenu: number;
		setActiveSubMenu: Dispatch<SetStateAction<number>>;
	}
}

export const Menu = (props: PropsWithChildren<TMenuProps>) => {
	const { children } = props;

	return (
		<div className={styles.menu}>
			{children}
		</div>
	);
}
Menu.displayName = 'Menu';
